import { Conversation } from 'generated-graphql/types';

export const getListOfParticipantsText = (
  conversations: Conversation[]
): string => {
  const participants = conversations.map((conversation) =>
    `${conversation?.participantFirstName || ''} ${
      conversation?.participantLastName || ''
    }`.trim()
  );

  return `${participants.length} - ${participants.join(', ')}`;
};
